import CardBody from 'components/card/CardBody'
import NavbarInput from 'components/form/NavbarInput'
import Paginator from 'components/Paginator'
import ToggleSwitch from 'components/toggleSwitch/ToggleSwitch'
import { debounce, isEmpty } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getFulfillmentOperators,
  updateFulfillmentOperatorStatus,
} from 'redux/slices/fulfillmentOperatorSlice'
import CustomTableItemLoader from '../../../components/CustomTableItemLoader'
import CustomTable, {
  TableCell,
  TableHeader,
  TableRow,
} from '../../../components/table/CustomTable'

const OPERATOR_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

const FulfillmentOperatorsList = ({ onRemove, onEdit, onPreviewBookings }) => {
  const dispatch = useDispatch()
  const { operators, loading, error, page, totalPages } = useSelector(
    (state) => state.fulfillmentOperator,
  )

  const [searchVal, setSearchVal] = useState('')

  // Fetch on mount
  useEffect(() => {
    dispatch(getFulfillmentOperators({ page: 1, word: '' }))
  }, [dispatch])

  const debouncedSearch = useCallback(
    debounce((word) => {
      dispatch(getFulfillmentOperators({ page: 1, word }))
    }, 500),
    [dispatch],
  )

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchVal(value)
    debouncedSearch(value)
  }

  const handlePageChange = (pageNumber) => {
    dispatch(getFulfillmentOperators({ page: pageNumber, word: searchVal }))
  }

  return (
    <CardBody>
      <div className="flex items-end justify-between">
        <div className=" mb-5 border border-gray-300 rounded">
          <NavbarInput
            value={searchVal}
            placeholder="Search operator"
            onChange={handleSearchChange}
          />
        </div>
      </div>
      <CustomTable>
        <FulfillmentOperatorsTableHeader />

        <FulfillmentOperatorsTableList
          operatorsList={operators}
          loading={loading}
          onRemove={onRemove}
          onEdit={onEdit}
          onPreviewBookings={onPreviewBookings}
          error={error}
        />
      </CustomTable>

      <Paginator
        currentPage={page}
        totalPages={totalPages}
        onClick={handlePageChange}
        loading={loading}
      />
    </CardBody>
  )
}

const FulfillmentOperatorsTableHeader = () => {
  const Headers = ['Name', 'Mobile', 'Gender', 'Status']

  const MapHeaders = Headers.map((value, index) => {
    return <TableHeader key={index}>{value}</TableHeader>
  })

  return (
    <>
      <thead>
        <TableRow>{MapHeaders}</TableRow>
      </thead>
    </>
  )
}

const FulfillmentOperatorsTableList = ({
  operatorsList = [],
  loading = false,
  onRemove,
  onEdit,
  onPreviewBookings,
  error,
}) => {
  const dispatch = useDispatch()

  const operatorsListMap = operatorsList.map((operator) => {
    const isOperatorActive = operator.status === OPERATOR_STATUS.ACTIVE
    return (
      <TableRow key={operator.id}>
        <TableCell isActive={isOperatorActive}>
          {operator?.first_name} {operator?.last_name}
        </TableCell>
        <TableCell isActive={isOperatorActive}>{operator?.mobile}</TableCell>
        <TableCell isActive={isOperatorActive}>{operator?.gender}</TableCell>
        <TableCell>
            <ToggleSwitch
              isChecked={isOperatorActive}
              onChange={() => {
                dispatch(
                  updateFulfillmentOperatorStatus({
                    operatorId: operator.id,
                    status:
                      operator.status === OPERATOR_STATUS.ACTIVE
                        ? OPERATOR_STATUS.INACTIVE
                        : OPERATOR_STATUS.ACTIVE,
                  }),
                )
              }}
            />
        </TableCell>
      </TableRow>
    )
  })

  return (
    <>
      {loading || isEmpty(operatorsList) || error.length > 0 ? (
        <CustomTableItemLoader
          loading={loading}
          error={error}
          isEmpty={isEmpty(operatorsList)}
          count={10}
          colSpan={4}
          key="shift-list"
          retry={() => {
            dispatch(getFulfillmentOperators())
          }}
        />
      ) : (
        <tbody>{operatorsListMap}</tbody>
      )}
    </>
  )
}

export default FulfillmentOperatorsList
